/**
 * Service for sentry (Raven.js)
 * Kept the naming the same as the segement service incase we combine the two later.
 *
 * @author Matthew Rawson @ 17/10/2017 17:48
 */
import Raven from "raven-js";
import authentication from "@irati/auth";
import { PIPELINE_ENVIRONMENTS } from "../../constants/environment";
import parseEmail from "./helpers/parseEmail";
import shouldSendCallback from "./helpers/shouldSendCallback";
import dataCallback from "./helpers/dataCallback";
import getSentryUrl from "./helpers/getSentryDNS";
import env from "../../env";
// only allow our domain
var whitelistUrls = [/perkbox\./];
var ignoreErrors = [
    /Network Error/,
    /status code 401/,
    /timeout of 0ms exceeded/ // annoying
];
var setup = function () {
    if (PIPELINE_ENVIRONMENTS.indexOf(env.ENVIRONMENT_NAME) > -1) {
        var key = getSentryUrl(env.ENVIRONMENT_NAME);
        Raven.config("https://" + key, {
            release: env.ENVIRONMENT_NAME + "__" + env.BUNDLE_REF,
            environment: env.ENVIRONMENT_NAME,
            whitelistUrls: whitelistUrls,
            ignoreErrors: ignoreErrors,
            shouldSendCallback: shouldSendCallback,
            dataCallback: dataCallback
        }).install();
    }
};
/**
 * Needs to wrap the app init to ensure all context is captured. Doesn't matter if it isn't in a pipeline environment
 * or if the Raven.config().install() hasn't run.
 *
 * @param: function - contains the react.render function
 */
var context = function (func) {
    Raven.context(function () {
        /** Inject sitewide context */
        Raven.setExtraContext({
        // none?
        });
        func();
    });
};
var setIdentity = function () {
    var user = authentication.user();
    Raven.setUserContext({
        id: user.uuid,
        email: parseEmail(user.email),
        username: user.firstname
    });
};
var clearIdentity = function () {
    Raven.setUserContext();
};
/**
 * Sending the whole error stack + msg to sentry. Also sends error.response if exists
 *
 * @author Richard Scoones @ 27/10/2017
 */
var captureException = function (e) {
    Raven.context(function () {
        var error = {
            name: e.name,
            message: e.message,
            stack: e.stack
        };
        if (e.response) {
            error.response = e.response.data;
            error.config = e.response.config;
        }
        Raven.captureException(e, { extra: { error: error } });
    });
};
export default {
    setup: setup,
    context: context,
    setIdentity: setIdentity,
    clearIdentity: clearIdentity,
    captureException: captureException
};
